
<template>
    <div class=" animated fadeIn fixed z-50 pin bg-smoke-dark flex" style="z-index: 1000 !important;">
        <div class=" modal mt-4 md:mt-0 rounded-lg fixed modal-width max-w-lg md:relative md:pin-b pin-x align-top m-auto justify-end md:justify-center bg-white rounded-lg md:h-auto md:shadow flex flex-col ">
            <div class=" modal-inner relative flex item-align flex-col" style=" padding:0 3rem 3rem 3rem">
<!-- header -->
              <div class="modal-container" v-if="!formSend">
                    <div  class="modal-header">
                    <p>Запрос в тех. поддержку</p>
                </div>
<!-- username and email -->
                <div class="user-email">
                  <div class="user-input-wrp user-name">
                                   <input type="text" class="inputText" required v-model="form.name"/>
                                   <span class="floating-label">Имя и фамилия</span>
                  </div>
                   <div class="user-input-wrp email">
                                   <input type="text" class="inputText" required v-model="form.email"/>
                                   <span class="floating-label">E-mail</span>
                  </div>
                </div>
<!-- select box -->
<div class="font-bold flex flex-row mt-8 text-menuOrder-dark-blue relative ref justify-between border border border-additional-text rounded cursor-pointer"  @click="showOptions()">
  <div data-v-16b11ca0="" class="text-sm py-2 px-2 text-main-text whitespace-no-wrap text-additional-text font-normal" >{{this.selectOption}}</div>
                  <img class="mr-2 ml-4 w-3" src="@/assets/SVG/arrow_down.svg"/>
                  </div>

<!-- show options -->
<div class="show-box-outer">
<div ref="showBox"
      class="show-box-inner mb-5 bg-white items-center z-10 border-additional-text rounded border py-1 max-h-third-screen overflow-y-auto"
      v-show="showBox">
        <div class="select-Item w-full flex py-2 flex-row justify-between px-4 cursor-pointer select-none font-medium selectedLabel"
        v-for="(listItem, index) in listItems" :key="index" @click="setSelectedOption(listItem.name)">
        <p class="text-sm" >
          {{listItem.name}}
        </p>
        <img v-if="!listItem.disabled" src="@/assets/SVG/tick.svg" alt="">
       </div>

    </div>
</div>

    <!-- text area -->
      <div class="text-area mt-4">
               <textarea   class="placeholder-additional-text w-full h-48 mb-4 border border-additional-text outline-none p-4 text-main-text rounded-lg"
                        placeholder="Комментарий"
                        v-model="form.comment"></textarea>

      </div>

            <!-- button to upload file  -->
                    <div class="upload-file-support flex">
                        <input type="file" name="" id="file" class="input" @change="getFile">
                        <label for="file" class="input-label" >
                          <img src="@/assets/icon.png" alt="" style="cursor: pointer;">
                        </label>
                           <p class="support-label">
                            Добавить файл
                          </p>
                    </div>
                    <!-- showing file names -->
                <div  style="margin-top:1rem">
                  <div v-for="(file, index) in form.files" :key="index" class="showFiles">
                    <div class="deleteFile" @click="deleteFile(index)">
                      <img src="@/assets/delete.png" alt="">
                    </div>
                    <p>
                      {{file.name}}
                    </p>
                  </div>
                </div>

                <!-- submit button -->
                <div class="submit">
                  <button :disabled="disabled" @click="sendForm" :class="{buttonenable : !disabled}">Отправить</button>
                </div>


              </div>

                <div class="font-medium text-center" style="margin:8rem 0" v-else >
                    <h2 class="text-2xl">Ваш запрос принят!</h2>
                     <br>Ожидайте ответ на указанню почту.
                </div>
            </div>


            <span @click="close" class="absolute pin-t pin-r md:pt-6 md:px-10 p-3">
                <img class="hover:text-grey-darkest cursor-pointer h-4" src="@/assets/SVG/cross-partners.svg"/>
            </span>
        </div>
    </div>
</template>

<script>
import Form from 'form-backend-validation';
import base from '../../clients/auth';

export default {
  data() {
    return {
      id: '',
      title: '',
      selectOption: 'Выбрать причину',


      listItems: [
        { id: 0, name: 'Не могу авторизоваться', reasonId: 'not_pay' },
        { id: 1, name: 'Не могу выбрать свою команду', reasonId: 'promo_code_does_not_work' },
        { id: 2, name: 'Не могу зарегистрироваться', reasonId: 'game_does_work' },

      ],
      form: new Form({
        reason: '',
        comment: '',
        email: '',
        name: '',
        files: [], // array that store files a user will upload
      }),

      formSend: false,
      disabled: true,
      showBox: false,
    };
  },
  methods: {
    send() {

    },
    close() {
      this.$emit('closeSupportModal');
    },
    showOptions() {
      this.showBox = !this.showBox;
    },
    setSelectedOption(getValue) {
      this.selectOption = getValue;
      this.showBox = false;
      this.form.reason = getValue;
    },
    // put files into array
    getFile(event) {
      this.form.files.push(event.target.files[0]);
    },
    // delete files from array
    deleteFile(index) {
      this.form.files.splice(index, 1);
    },
    sendForm() {
      this.form.post(`${process.env.VUE_APP_MP_BACKEND}/support?site=portal`).then(() => {
        this.sent = true;
        setTimeout(() => this.$emit('closeSupportModal'), 2000);
      }).catch((error) => { this.errors = error.response; });
      this.formSend = true;
      setTimeout(() => {
        this.$emit('closeSupportModal');
      }, 3000);
    },
  },
  watch: {
    'form.comment': function () {
      if (this.form.reason != '' && this.form.comment != '' && this.form.name != '' && this.form.email != '') {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
  },

};
</script>

<style scoped>
    .modal-width {
        width: 700px;
        top: 40px;
        height: 80vh;
    }

    .header-bg {
        border-radius: 0 0 100% 100%;
    }
    .modal-header {
      font-family: Montserrat;
font-style: normal;
font-weight: bold;
font-size: 18px;
line-height: 22px;
color: #333333;
margin-top: 61px;
margin-bottom: 41px;
display: flex;
justify-content: center;
    }
    .user-email{
      display: flex;
    }

.user-input-wrp {
position: relative;
width: 50%;
}
.user-input-wrp .inputText{
width:90%;
outline: none;
border:none;
border-bottom: 1px solid #979797;
box-shadow: none !important;
margin: 10px;
font-family: Montserrat;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 17px;
color: #333333;
}
.user-input-wrp .inputText:focus{
border-color: #BD006C;
}
.user-input-wrp .floating-label {
position: absolute;
pointer-events: none;
top: 0px;
left: 10px;
transition: 0.2s ease all;
font-family: Montserrat;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 17px;
color: #979797;
}
.user-input-wrp input:focus ~ .floating-label,
.user-input-wrp input:not(:focus):valid ~ .floating-label{
top: -10px;
left: 10px;
font-size: 13px;
opacity: 1;
}
.user-name{
}
.email{}
.text-area{
  position: relative;
}
.select-Item:hover{
      color: white;
    background-color: #BD006C;
}
.show-box-outer{
  position: relative;
}
.show-box-inner{
  position: absolute;
  width: 100%;
}
.showFiles{
margin:2px;
/* background:#bd006c; */
border: 1px solid grey;
padding: 2px 0 2px 5px;
border-radius: 10px ;
position: relative;
}
.input{
  display: none;
}
.deleteFile{
    position: absolute;
    border-radius: 50px;
    right: 5px;
    top: 2px;
    cursor: pointer;
}
.support-label{
font-family: Montserrat;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 17px;
color: #979797;
margin-left: 0.5rem;
padding: 0.4rem 0;
}
.submit{
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.submit button{
background: #DADADA;
border-radius: 45px;
padding: 10px 6rem;
font-family: Montserrat;
font-style: normal;
font-weight: bold;
font-size: 14px;
line-height: 17px;
text-align: center;
color: #FFFFFF;
cursor: pointer;
outline:none;
}
.buttonenable{
background: #BD006C !important;
}


    @media (max-width: 840px) {
      .modal-width {
        width: 500px;
      }
    }

@media (max-width: 640px) {
.modal-width {
  width: 340px;
}
.modal-header{
  margin-top: 0;
}
.modal{
  justify-content: center !important;
}
.user-email{
display: block;
}
.user-input-wrp{
  width: 100%;
}
.modal-inner{
  padding: 0px 1rem !important;
}
.user-name {
    margin-bottom: 1rem;
}

}

</style>
